module.exports = __webpack_public_path__ + "static/SocialApp-6ea06e6b24e966f56a73c0e77a7ad258.svg";